import { render, staticRenderFns } from "./DeliveryPointDescriptionCard.vue?vue&type=template&id=472cd194&scoped=true"
import script from "./DeliveryPointDescriptionCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointDescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointDescriptionCard.vue?vue&type=style&index=0&id=472cd194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cd194",
  null
  
)

export default component.exports